(function certificateModuleDefinition() {
    'use strict';

    angular.module('Certificate', ['ngFileUpload', 'ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'FileDownloader', 'DoublyLinkedList', 'informationBoxControl', 'DocumentViewer',
    ])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function certificateConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('certificate-detail', {
                    url: "/Certificate/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/certificate/certificate-detail.html'),
                    controller: 'CertificateDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CERTIFICATECUSTOMER READ').or('CERTIFICATECUSTOMER WRITE')
                });

                $stateProvider.state('certificate-find', {
                    url: "/Certificate/Find",
                    templateUrl: config.resourceUrl('/views/certificate/certificate-find.html'),
                    controller: 'CertificateFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CERTIFICATECUSTOMER READ').or('CERTIFICATECUSTOMER WRITE')
                });

                $stateProvider.state('certificate-edit', {
                    url: "/Certificate/{id}",
                    templateUrl: config.resourceUrl('/views/certificate/certificate-edit.html'),
                    controller: 'CertificateEditController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CERTIFICATECUSTOMER READ').or('CERTIFICATECUSTOMER WRITE')
                });
            }
        ]);
})();
